module.exports = __webpack_public_path__ + "static/assets/twitter-logo.cec3920.png";